<div  [ngStyle]="{'background-color':color?.PrimaryColor}" style="background-color:rgb(234,250,254);overflow-y: scroll ;max-height:100% ;" >
  <!--(scroll)="onScroll($event)"  -->
<span #tops></span>

<app-flight   style="font-size: small; "  [class]="pointerEvents?('pointerEventsNone'):''" (myOutput)="searchFlight()" ></app-flight>

<div class=" col-lg-12  " style="max-width: 100%; margin-top: -80px;position: relative;  width:100%;"  > 
<div class=" col-md-12 " style="margin-top: 20px;">
 
<!--###################################   Filter ##################################################
     ###################################   Filter ################################################## 
      ###################################   Filter ##################################################-->
  
<!-- <div *ngIf="returnflight" class="col-md-2 scrollable-div " style="height: 78vh; overflow-y: auto; font-size: 12px;" >
   <div class="row">
    <span class="col-md-7" *ngIf="flightDetail"> {{flightDetail?.length+returnFlightDetail?.length}} of  {{this.returnflight[0]?.flights?.length+this.returnflight[1]?.flights?.length}} Flights</span>
    <span class="col-md-5 d-flex justify-content-end  close" routerLink="/app/flight"   > <mat-icon>arrow_back</mat-icon></span>
  </div>
    <mat-expansion-panel  style="margin-top: 30px;">
       <mat-expansion-panel-header>
       <mat-panel-title>
       <span >Stops</span> 
       </mat-panel-title>
       </mat-expansion-panel-header>
      
       <mat-selection-list [(ngModel)]="stop" (click)="stops()" >
          <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1">Non-stop</mat-list-option>
          <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2">1 stop</mat-list-option>
          <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3">2 stop</mat-list-option>

      </mat-selection-list>
      
      </mat-expansion-panel>

       <mat-expansion-panel  style="margin-top: 20px; ">
       <mat-expansion-panel-header>
       <mat-panel-title>
        Departure time
       </mat-panel-title>
       </mat-expansion-panel-header>
       <mat-selection-list [(ngModel)]="filterTime" (click)="DepartureTime()" >
        <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning">Early morning (Midnight - 8AM)</mat-list-option>
        <mat-list-option color="primary" checkboxPosition="before" value="morning">Morning (8AM-Noon)</mat-list-option>
        <mat-list-option color="primary" checkboxPosition="before" value="afternoon">Afternoon (Noon - 4PM)</mat-list-option>
        <mat-list-option color="primary" checkboxPosition="before" value="evening">Evening (4PM - 8PM)</mat-list-option>
        <mat-list-option color="primary" checkboxPosition="before" value="night">Night (8PM - Midnight)</mat-list-option>

        </mat-selection-list>

      
      </mat-expansion-panel> -->

     <!-- <mat-expansion-panel  style="margin-top: 20px; ">
       <mat-expansion-panel-header>
       <mat-panel-title>
        One-way price
       </mat-panel-title>
       </mat-expansion-panel-header>
          
       </mat-expansion-panel> -->
    <!-- <mat-expansion-panel  style="margin-top: 20px; ">
       <mat-expansion-panel-header>
       <mat-panel-title>
        Airlines
       </mat-panel-title>
       </mat-expansion-panel-header> -->
       <!-- <mat-slide-toggle style="font-size: 14px;" >Show multiple airlines</mat-slide-toggle>
       <br>
       <mat-slide-toggle style="font-size: 14px;" >Air Asia</mat-slide-toggle>
       <br>
       <mat-slide-toggle style="font-size: 14px;" >Air India</mat-slide-toggle>
       <br>
       <mat-slide-toggle style="font-size: 14px;" >Air India Express</mat-slide-toggle>
       <br>
       <mat-slide-toggle style="font-size: 14px;" >Akasa Air</mat-slide-toggle>
       <br>
       <mat-slide-toggle style="font-size: 14px;" >IndiGo</mat-slide-toggle>
       <br>
       <mat-slide-toggle style="font-size: 14px;" >Spicejet</mat-slide-toggle>
       <br>
       <span style="color: blue;font-size: 14px;">See more</span> -->
       <!-- <mat-selection-list  [(ngModel)]="airlines" (click)="filterAirlines()">
        <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName">{{fligthNameFilter(flightName)}}</mat-list-option>
        
    </mat-selection-list>
       </mat-expansion-panel> -->
     <!-- <mat-expansion-panel  style="margin-top: 20px; ">
        <mat-expansion-panel-header>
         <mat-panel-title>
          Trip duration
         </mat-panel-title>
         </mat-expansion-panel-header>
       
       </mat-expansion-panel> -->
      <!-- <mat-expansion-panel  style="margin-top: 20px; ">
         <mat-expansion-panel-header>
         <mat-panel-title>
          Layover duration
         </mat-panel-title>
         </mat-expansion-panel-header>
       
      </mat-expansion-panel> -->
<!-- </div> -->
 
<div  *ngIf="returnflight"   class="col-md-12">

  
  
  <!--##############filter#################=============================================================================-->
<!--###################################   filter ##################################################
     ###################################  filter ################################################## 
      ################################### filter ##################################################-->
      <mat-expansion-panel   hideToggle disabled class=" sticky-tabs" style=" margin-left: 20px; margin-right: 20px; min-width:1200px ; min-height: 50px;">
   
        <mat-expansion-panel-header style="background-color: transparent;">
          <!-- <mat-panel-title style="background-color: transparent;"> -->
            <!-- <span style="color:blue">Sort : </span>
            &nbsp;
            <span style="color:#007bff ;" (click)="combineFlilter('airline')">Airlines</span>
            &nbsp;
            <span style="color:#007bff ;" (click)="combineFlilter('departs')">Departs</span>
   -->
  <!-- </mat-panel-title> -->
          <mat-panel-title style="background-color: transparent;">
            
            <div class="col-md-12 row  bold " style="color:rgb(32,32,32); font-size: 18px;">
              <!-- <div class="col-md-2  d-flex justify-content-start">Airline</div>
              <div class="col-md-4 d-flex justify-content-center">
                  <div class="col-md-4 mb-1">Departure</div>
                  <div class="col-md-4 mb-1"></div>
                  <div class="col-md-4 mb-1">Arrival</div>
                </div> -->
 <!-- <input type="number" placeholder="Enter min base fare" [(ngModel)]="minBaseFare">
<button (click)="filterByBaseFare(minBaseFare)">Filter by Base Fare</button> -->

                <div  [class]="rules?('col-md-12  d-flex justify-content-end'):'col-md-12  d-flex justify-content-end'" >
                  <span *ngIf="rules" style="color: 017BFE;font-size: 13px;white-space: nowrap;padding-top: 10px;">
                    <p-checkbox 
            [(ngModel)]="Incv" 
            [binary]="true" 
            inputId="binary" 
            label="Show Incv"/> 
<span style="padding-right: 8px; padding-left: 5px; ">
            <p-checkbox 
            [(ngModel)]="net" 
            [binary]="true" 
            inputId="binary" 
            label="Show Net"/> 
          </span>
          </span>
                  <!-- <p-splitButton 
                  label="Save" 
                  [model]="sortInfo" /> -->
     
                  <!-- (onClick)="save('info')"  -->
            <span class="mt-2" style="white-space: nowrap;">
            <span style="color:#007bff;font-size: small;">Sort : </span>
            &nbsp;
            <span class="hoverLine" style="color:#007bff ;font-size: small;" (click)="combineFlilter('airline')">Airlines</span>
            &nbsp;
            <span class="hoverLine" style="color:#007bff ;font-size: small;" (click)="combineFlilter('departs')">Departs</span>
            &nbsp;
            <span class="hoverLine" style="color:#007bff ;font-size: small;"(click)="combineFlilter('arrives')" >Arrives</span>
            &nbsp;
            <span class="hoverLine" style="color:#007bff ;font-size: small;"(click)="combineFlilter('price')" >Price</span>
            &nbsp;
            &nbsp;


          </span>
                  <!-- <div style="min-width:100px; padding: 4px; margin-right: 8px;"></div> -->
                  <div class=" "   style="min-width:100px; padding: 4px; margin-right: 8px;" >
                    <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
                      <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
                      <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
                    </mat-slide-toggle>
                  
                  
                    <mat-menu #showShareDialog="matMenu"  >
                      <button mat-menu-item (click)="shareEmailPopup()">
                        <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                        <span>Link</span>
                      </button>
                      <button mat-menu-item (click)="sendAllData()">
                        <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                        <span>All</span>
                      </button>
                      <button mat-menu-item (click)="shareEmailPopup()">
                        <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                        <span>Filter</span>
                      </button>
                      <button mat-menu-item (click)="sendSelectedData()">
                        <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                        <span>Selected</span>
                      </button>
                      <!-- <mat-selection-list   [multiple]="false">
                        <mat-list-option color="primary" checkboxPosition="before" value="link"  style="font-size: 12px;">Link</mat-list-option>
                        <mat-list-option (click)="sendAllData()" color="primary" checkboxPosition="before" value="all" (click)="shareEmailPopup()" style="font-size: 12px;"><mat-icon>done_all</mat-icon>All</mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="filter" (click)="shareEmailPopup()" style="font-size: 12px;"><mat-icon>filter_list</mat-icon>Filter</mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="selected" (click)="shareEmailPopup()" style="font-size: 12px;"><mat-icon>done_all</mat-icon>Selected</mat-list-option>

                       
                        </mat-selection-list> -->
                    </mat-menu> 
                  </div> 

                  <!-- <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div>  -->

                  <div class="d-flex justify-content-end" style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{minPrice}}</div>

                  <div class=" " style="min-width:100px;  margin:0;  margin-top:-4px ; padding: 0;"  > 
                     <mat-slider     
                    style="margin: 0;padding: 0;  "
                    class="example-margin"
                    [max]="maxPrice"
                    [min]="minPrice"
                    step="0"
                    [discrete]="'true'"
                    [showTickMarks]="'false'">
                  <input matSliderThumb [(ngModel)]="value" (input)="combineFilters()" #slider>
                </mat-slider></div> 

                  <div style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{maxPrice}}</div>
                  
                  <div class=" "style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="showTimeDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Time </button>
                    
                    <mat-menu #showTimeDialog="matMenu"  >
                      <mat-selection-list [(ngModel)]="filterTime" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 12px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
                       
                        <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 12px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 12px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 12px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
                
                        </mat-selection-list>
                    </mat-menu> </div> 
                  <div class=" "  style="padding: 4px; margin-right: 8px; " [matMenuTriggerFor]="OpenDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Stops </button>
                    <mat-menu #OpenDialog="matMenu" >
                      <mat-selection-list [(ngModel)]="stop" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
              
                    </mat-selection-list>
                    </mat-menu>
                  </div> 
                  <div class=" " style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="OpenAirDialog" aria-label="Example icon-button with a menu" ><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Airlines </button>
                    <mat-menu #OpenAirDialog="matMenu" >
                      <mat-selection-list  [(ngModel)]="airlines" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                        
                    </mat-selection-list>
                    </mat-menu>
                  </div> 
                  <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;"  [matMenuTriggerFor]="OpenfareTypeDialog" aria-label="Example icon-button with a menu"><button mat-raised-button  > Fare&nbsp;Type</button>
                  
                    <mat-menu #OpenfareTypeDialog="matMenu" >
                      <mat-selection-list [(ngModel)]="fareType" (click)="combineFilters()" (click)="onMenuClick($event)">
                        <mat-list-option color="primary" *ngFor="let item of fareTypeMenu" checkboxPosition="before" [value]="item" style="font-size: 12px;">{{item}}</mat-list-option>
                      
                    </mat-selection-list>
                    </mat-menu>
                  
                  </div> 
    
                  
                 
                 
                </div>  
            </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
       
      </mat-expansion-panel>
        <!--##############OneWay#################=============================================================================-->
<!--###################################   OneWay ##################################################
     ###################################  OneWay ################################################## 
      ################################### OneWay ##################################################-->
<span *ngIf="messageData.airSearchRequestBaseDetails.length===1">
  
  <div style=" min-width:1300px;white-space: nowrap; padding-top: 20px; " >
    <!-- [expanded]="true" hideToggle  disabled="true"
    (click)="setStep(1);" -->
    <mat-accordion class="example-headers-align" multi style="margin-top: 10px; " >
  <mat-expansion-panel *ngFor="let item of  flightDetail"  [expanded]="item.selected" disabled hideToggle  [ngClass]="{'active' :item.selected}"        style="margin-top: 5px;  margin-left: 20px; margin-right: 20px; ">
    <mat-expansion-panel-header   style="padding-top: 37px; padding-bottom: 55px; display: flex;align-items: center;">

      <mat-panel-title style="color: rgb(33,33,33); " >
        <div class="col-md-12 row pt-3 pb-1">
          <div class="col-md-2 d-flex justify-content-start pt-4" >
            <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

               
               
                <div style="font-size: 14px; min-width: 8%">
                  <div>{{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}</div>
                  <div style="font-size: 13px; color: grey;white-space:nowrap; ">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}<br>
                    <!-- <img *ngIf="item?.flightDetailsList[0]?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
                    <span >{{item?.flightDetailsList[0]?.equipmentType}}</span>  -->

                    <!-- <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
                    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
                    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
                    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span>  -->
                   <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                    <br><span class="bold"  *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>
                  </div>
                </div>
          </div>
          <div class="col-md-4 pt-4 d-flex justify-content-center" >
                <div class="col-md-4 bold" >{{item?.schDepartureTime | date:'HH:mm'}}<br>{{item?.flightDetailsList[0]?.fromAirport}}</div> 

                <div class="col-md-4"><div class="d-flex justify-content-start" style="padding-left: 10px;">{{converter(item?.travelDuration)}} 

                 
                </div>
                <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(12, 121, 39) ;max-width: 60%;" ></div>
                <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;max-width: 60%;"></div>
                <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;max-width: 60%;"></div>

                  <div class="d-flex justify-content-start" *ngIf="item?.hopCount===1" (click)="popoveritemContent.toggle($event)" style="font-size: 13px; color: grey; padding-left: 10px;">{{item?.hopCount===1?('non-stop'):''}}</div>
                  <div class="d-flex justify-content-start" *ngIf="item?.hopCount!=1"  (click)="popoveritemContent.toggle($event)"style="font-size: 13px; color: grey; padding-left: 10px;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</div>

                  <p-overlayPanel  #popoveritemContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                    <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of item.flightDetailsList">
              
              <div class="mb-3 mt-1">
                <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
            </div><br>
          <div class="col-md-2">
            <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
        
          
        <br>
        {{fligthNameFilter(element?.carrierName)}}<br>
            <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
              <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
              <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
             <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
            -->
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
              <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
        
            </span>
        </div>
        
        <div class="col-md-2">
            {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
            <br>
            <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
            <br>
            <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
        </div>
        <div class="col-md-2">
            <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
            <br>
            <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
           
        </div>
        <div class="col-md-2">
          {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
            <br>
            <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
            <br>
            <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
        </div>
        <div class="col-md-2">
                
            <!-- <span style="font-size: 12px;">Check-in baggage</span>
            <br>
            <span style="font-size: 12px;">  Cabin baggage</span> -->
        </div>
        <div class="col-md-2">
            <!-- <span style="font-size: 13px;">20kg/ Adult</span>
             <br>
             <span style="font-size: 13px;">7kg/ Adult</span> -->
         </div>
            </div>
          </p-overlayPanel>


                </div>
                <div class="col-md-4 bold">{{item?.schArrivalTime | date:'HH:mm'}}<br>{{item?.flightDetailsList[item?.flightDetailsList.length-1]?.toAirport}}<small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
                  triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small></div>

          </div>
           
          <div class="col-md-6 row" >
                    <div class="col-md-10 pt-3  pb-2 d-flex justify-content-center" >  
                        <div  class="col md-6 row " [style]="item?.fare[0]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item?.fare[0]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item.fare[0]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                              <div *ngIf="item.fare[0]" class="col-md-12 row">
                                <div class="col-md-12 " (click)="setStep(0)" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;"> 
                                  <span *ngIf="!enableCheck"  (click)="onClickFare(item.fare[0], item.fare,item)">
                                  <mat-icon class="mat-primary" *ngIf="item.fare[0].selected==='true'">radio_button_checked</mat-icon>
                                  <mat-icon style="color: #757575;" *ngIf="item.fare[0].selected===''">radio_button_unchecked</mat-icon>
                                  
                                  <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                                  triggers="mouseenter:mouseleave">
                                  ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{item?.fare[0]?.netFare}}</span> 
                                  <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    item?.fare[0]?.commercialData?.finalAmount}} -->
                                  </span> 

                                </span>    
                                <span *ngIf="enableCheck" >
                                  <!-- <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,item,item?.fare[0])"></mat-checkbox> -->

                                  <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
                                  <mat-icon *ngIf="false"  class="mat-primary">check_box</mat-icon> -->
                                  <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                                  triggers="mouseenter:mouseleave">
                                  ₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax+item?.fare[0]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{item?.fare[0]?.netFare}}</span>
                                  <!-- ₹{{ (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    item?.fare[0]?.commercialData?.finalAmount}} -->
                                  </span> 

                                </span>        
                                  <!-- <mat-radio-group (click)="setStep(0)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="item.fare[0].selected" >
                                    <mat-radio-button  color="primary" class="example-radio-button "  (click)="onClickFare(item.fare[0], item.fare,item)"  value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;font-size: 18px;">₹{{item.fare[0]?.baseFare+item.fare[0]?.finalTax}}</span></mat-radio-button>
                                  </mat-radio-group> -->
                                  
                                </div>
                                 
                              </div>
                               <div class="col-md-12 row" >
                                    <span class="col-md-1 "></span>
                                    <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 10px;">{{item?.fare[0]?.refundable===true?('Refundable'):''}}</span>
                                    <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[0]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 10px;"> {{item?.fare[0]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                                    <span class="col-md-1 "></span>
                                    <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                                    <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[0]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 10px;">{{item?.fare[0]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                                  </div>
                              <div *ngIf="item.fare[0]" class="col-md-12 bold row"style="padding-left: 23px;padding-top: 4px;">
                                <!-- <mat-checkbox (click)="setStep(0)" color="primary" class="example-ripple-checkbox">{{item.fare[0].fareType}}</mat-checkbox>                        -->

                                <span (click)="setStep(0)" color="primary" >
                                  {{item.fare[0].fareTypeDisplay}} <span *ngIf="Incv" style="color: grey;font-size: 14px;">&nbsp; Incv ₹{{item?.fare[0]?.incentiveAmt}}</span>
                                  <!-- {{item.fare[0]?.corporateFare?("Corporate"):item.fare[0].fareType}} -->
                                </span>                       
                              </div> 

                                <!-- <div class="col md-7"  ><span style=" color:rgb(1,123,254);cursor: pointer; font-weight: 600;" [ngbPopover]="popoverContent" container="body"
                                  triggers="mouseenter:mouseleave">&#8377;{{item.fare[0].baseFare+item.fare[0]?.finalTax}} </span></div> -->
                        </div>
                        <div  class="col md-6 row " [style]="item?.fare[1]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;'):''||item?.fare[1]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||item.fare[1]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                              <div  *ngIf="item.fare[1]" class="col-md-12 row">
                                <div (click)="setStep(0)" class="col-md-6" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;">
                                  <span *ngIf="!enableCheck" (click)="onClickFare(item.fare[1], item.fare,item)" >

                                  <mat-icon class="mat-primary" *ngIf="item.fare[1].selected==='true'">radio_button_checked</mat-icon>
                                  <mat-icon  style="color: #757575;" *ngIf="item.fare[1].selected===''">radio_button_unchecked</mat-icon>
                                  
                                  
                                  <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popover1Content" container="body"
                                  triggers="mouseenter:mouseleave">
                                  ₹{{item.fare[1]?.baseFare+item.fare[1]?.finalTax+item?.fare[1]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{item?.fare[1]?.netFare}}</span>
                                  <!-- ₹{{
                                    (passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    item?.fare[1]?.commercialData?.finalAmount}} -->
                                
                                </span>
                                  </span>
                                  <span *ngIf="enableCheck" >

                                    
                                    <!-- <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,item,item?.fare[1])"></mat-checkbox> -->
                                    
                                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popover1Content" container="body"
                                    triggers="mouseenter:mouseleave">
                                    ₹{{item.fare[1]?.baseFare+item.fare[1]?.finalTax+item?.fare[1]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{item?.fare[1]?.netFare}}</span>
                                    <!-- ₹{{
                                      (passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                      (passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                      (passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                      (passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      item?.fare[1]?.commercialData?.finalAmount}}-->
                                    </span> 
                                    </span>
                                    <!-- <mat-radio-group (click)="setStep(0)" aria-labelledby="example-radio-group-label" class="example-radio-group"  [(ngModel)]="item.fare[1].selected">
                                      <mat-radio-button  color="primary" class="example-radio-button "   (click)="onClickFare(item.fare[1], item.fare,item)" value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;"></span></mat-radio-button>
                                    </mat-radio-group> -->
                                   
                                </div>
                                <div class="col-md-12 row">
                                  <span class="col-md-1 "></span>
                                  <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[1]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 11px;">{{item?.fare[1]?.refundable===true?('Refundable'):''}}</span>
                                  <span class="col-md-6 d-flex justify-content-center" *ngIf="item?.fare[1]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 11px;"> {{item?.fare[1]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                                  <span class="col-md-1 "></span>
                                  <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[1]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 11px;">{{item?.fare[1]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                                  <span class="col-md-3 d-flex justify-content-center" *ngIf="item?.fare[1]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 11px;">{{item?.fare[1]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                                </div>
                              </div>
                              
                              <div  *ngIf="item.fare[1]" class="col-md-12 bold row" style="padding-left: 23px;padding-top: 4px;">
                                <!-- <mat-checkbox  (click)="setStep(0)" color="primary" class="example-ripple-checkbox">{{item.fare[1].fareType}} </mat-checkbox> -->
                                <span  (click)="setStep(0)" color="primary" > 
                                  <!-- {{item.fare[1]?.corporateFare?("Corporate"):item.fare[1].fareType}} -->
                                  {{item.fare[1]?.fareTypeDisplay}} <span *ngIf="Incv" style="color: grey;font-size: 14px;">&nbsp; Incv ₹{{item?.fare[1]?.incentiveAmt}}</span>

                                </span>
                              </div> 

                                <!-- <div class="col md-7"  ><span style=" color:rgb(1,123,254);cursor: pointer; font-weight: 600;" [ngbPopover]="popoverContent" container="body"
                                  triggers="mouseenter:mouseleave">&#8377;{{item.fare[0].baseFare+item.fare[0]?.finalTax}} </span></div> -->
                        </div>
                    <ng-template #popoverContent class="col-md-12"  >
                  <div class="  col-md-12 ">

                  <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                                style="overflow-y:scroll;max-height: 95%; width: 100%;">
                                <thead class="thead-light" style="white-space:nowrap;">
                                  <tr>
                                    <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                    <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                    <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                                  </tr>
                                </thead>
                                <tbody >
                                  <tr  style="height: 25px; ">
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].baseFare}}</td>
                                  
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[0].finalTax}}</td>
                                    <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                      {{
                                        (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                        (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                        (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                      }}</td>
                                  
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{
                                      (passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                      
                                    }}</td> -->

                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                  
                                  
                                  </tr>
                                </tbody>
                              </table>
                              <div class=" mt-1" *ngIf="messageData.adultCount">
                                <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                                 <span> {{passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                                  <!-- <span style="padding:1px 4px 1px 4px;background-color: rgb(25,128,254);color: white;border-radius: 2px;">  {{(passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.bookingClass?((passengerTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.bookingClass):''}}</span> -->
                                            <!-- remove in hover only -->

                                  <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                    {{ entry.key }}{{ entry.value | json }},
                                   </span>) -->
                                </span>
                                
                             
                            </div>
                            <div class=" mt-1" *ngIf="messageData.childCount">
                              <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                              <span> {{passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                                <!-- <span style="padding: 4px;background-color: rgb(25,128,254);color: white;"> {{(passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.bookingClass?((passengerCTypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.bookingClass):''}}</span> -->
                                            <!-- remove in hover only -->

                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.infantCount">
                            <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                            <span> {{passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareBasis):''}}
                                            <!-- remove in hover only -->
                                           <!-- <span style="padding: 4px;background-color: rgb(25,128,254);color: white;"> {{(passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.bookingClass?((passengerITypeMapping(fareOMapping(item?.fare[0],item,item?.fare)))[0]?.bookingClass):''}}</span> -->

                
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(item?.fare[0],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>

                  </div>
                  </ng-template>
                  <ng-template #popover1Content class="col-md-12"  >
                    <div class="  col-md-12 ">
                    
                    <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                                  style="overflow-y:scroll;max-height: 95%; width: 100%;">
                                  <thead class="thead-light" style="white-space:nowrap;">
                                    <tr>
                                      <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                      <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                      <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                      <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
                    
                    
                    
                                    </tr>
                                  </thead>
                                  <tbody >
                                    <tr  style="height: 25px; ">
                                      <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                        {{
                                          (passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                          (passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                          (passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                          
                                        }}</td>
                                    
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{
                                        (passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                        (passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                        
                                      }}</td> -->
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[1].baseFare}}</td>
                                    
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.fare[1].finalTax}}</td>
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                    
                                    
                                    
                                    </tr>
                                  </tbody>
                                </table>
                               
                              <div class=" mt-1" *ngIf="messageData.adultCount">
                                <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                                 <span> {{passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareBasis):''}}
                
                                            <!-- remove in hover only -->

                                  <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                    {{ entry.key }}{{ entry.value | json }},
                                   </span>) -->
                                </span>
                                
                             
                            </div>
                            <div class=" mt-1" *ngIf="messageData.childCount">
                              <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                              <span> {{passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareBasis):''}}
                
                                            <!-- remove in hover only -->

                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.infantCount">
                            <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                            <span> {{passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareBasis):''}}
                
                                            <!-- remove in hover only -->

                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareMapping(item?.fare[1],item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry?.key }}{{ entry?.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                    
                    </div>
                    </ng-template>
                    

                  </div>
                  <div class="col-md-2 " style="padding-top: 33px;" *ngIf="!enableCheck">
                    <span *ngIf="tripEnable===false">
                    <button *ngIf="!showSpiner &&!item.selected "  mat-raised-button color="accent"   disabled >
                      Book
                    </button> 
                    <button *ngIf="!showSpiner && item.selected"  mat-raised-button color="accent"  (click)="openWindow(item)"  >
                      Book
                    </button> 
                     
                    <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book</button>
                  </span>
                  <span *ngIf="tripEnable===true">
                    <button *ngIf="!showSpiner &&!item.selected "  mat-raised-button color="accent"   disabled >
                      Select Flight
                    </button> 
                    <button *ngIf="!showSpiner && item.selected"  mat-raised-button color="accent"  (click)="openWindow(item)"  >
                      Select Flight
                    </button> 
                     
                    <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select Flight</button>
                  </span>
                <span style="position: relative; right:1%;top:10%">
                    <button *ngIf="item?.dropDown===false" mat-icon-button  (click)="selectFlight(item);onClickDepartureDown(item)">
                      <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
                    </button>
                  
                    <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickDepartureUp(item)">
                      <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
                    </button></span>
                     <!-- 
                     style=" border:1px solid rgb(1,123,254);"
                    <button    mat-icon-button *ngIf="item?.dropDown" (click)="onClickDepartureUp(item)">
                      <mat-icon style=" color:rgb(1,123,254);" class="mb-3">expand_less</mat-icon>
                    </button>-->
                </div>
              </div>
             
        </div>
        </mat-panel-title>
      
      
        
    </mat-expansion-panel-header>
    <!-- *ngIf="item?.dropDown===true" -->
    <div  class="col-md-12 row" *ngIf="item?.dropDown===true">
      <table class="styled-tables ">
        <thead>
          <tr  >
            <!-- Dynamic headers based on tableHeaders array -->
            <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
            <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
            <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
            <th style="padding: 8px;  text-align: center;text-align: left;"></th>

          </tr>
        </thead>
        <tbody class="box-shadow">
          <!-- Iterate through dynamic data rows -->
          <tr  *ngFor="let fare of item?.fare;" >
            <!-- Display structured data -->
            
            <td class=" " style="padding: 8px; " [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
                <span class="" >
                  <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
                  <mat-icon *ngIf="false" class="mat-primary">check_box</mat-icon> -->
                  
                    <mat-checkbox color="primary"  *ngIf="enableCheck"  (change)="selectShareData($event,item,fare)"></mat-checkbox>

                  <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                  {{fare?.fareTypeDisplay}}

                  
                </span>
              <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="onClickFare(fare, item.fare,item);openPopup(item,fare);onClickITINERARYTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>  
              <br><small *ngIf="parentType==='Staff'" style="color: rgb(194, 129, 8);">{{fare?.source}}</small>  
            </td>
            <td class="" style="padding: 8px;">
              <!-- <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===true" >{{fare?.refundable===true?('Refundable'):''}}</span>
              <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===false" > {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}</span> -->
              {{fare?.refundable===true?('Refundable'):''}}
              {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}
              <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="onClickFare(fare, item.fare,item);openPopup(item,fare);onClickCancellationTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    

            </td>
            
            <td class="" style="padding: 8px;">
              <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
              <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
            
            </td>
            <td class="name-type" style="padding: 8px;">
              {{fareOMapping(fare,item,item?.fare)[0]?.seatsAvailability}}
              

            </td>
            <!-- <td class="" style="padding: 8px;">{{ '' }}</td> -->
            <td class="" style="padding: 8px;">
              <!-- changefun fareOMapping -->
               {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}
            </td>
            <td class="" style="padding: 8px;">{{'7KG'}}</td>
            <td  style="padding: 8px;">
             <span class="bold d-flex justify-content-end" style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
             triggers="mouseenter:mouseleave">
             <span *ngIf="Incv" style="color: grey;font-size: 14px;"> Incv ₹{{fare?.incentiveAmt}}&nbsp;&nbsp;</span>
             <span *ngIf="net" style="color: grey;font-size: 14px;">  Net ₹{{fare?.netFare}}&nbsp;&nbsp;</span> 

              ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}} <br>
             
             
              <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                fare?.commercialData?.finalAmount}} -->
            </span>
             <div *ngIf="enableCheck" style="min-height: 5vh;"></div>
             <span *ngIf="tripEnable===false">

              <button *ngIf="!showSpiner&&!enableCheck" class="col-md-12 bold"  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;" (click)="onClickFare(fare, item.fare,item);openWindow(item)"  >
                Book
              </button>  
              <button  *ngIf="showSpiner&&!enableCheck" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;"  >Book</button>
             </span>
             <span *ngIf="tripEnable===true">

              <button *ngIf="!showSpiner&&!enableCheck" class="col-md-12 bold"  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;" (click)="onClickFare(fare, item.fare,item);openWindow(item)"  >
                Select Flight
              </button>  
              <button  *ngIf="showSpiner&&!enableCheck" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;"  >Select Flight</button>
             </span>
              <ng-template #popoverContent class="col-md-12"  >
                <div class="  col-md-12 ">

                <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                              style="overflow-y:scroll;max-height: 95%; width: 100%;">
                              <thead class="thead-light" style="white-space:nowrap;">
                                <tr>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                  <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                  <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                                </tr>
                              </thead>
                              <tbody >
                                <tr  style="height: 25px; ">
                                  <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                    }}</td>
                                
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                    {{
                                      (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                      (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                    }}</td> -->
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.baseFare}}</td>
                                
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.finalTax}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                
                                
                                
                                </tr>
                              </tbody>
                            </table>
                            <div class=" mt-1" *ngIf="messageData.adultCount">
                              <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                               <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
                            <!-- remove in hover only -->

                                <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                  {{ entry.key }}{{ entry.value | json }},
                                 </span>) -->
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.childCount">
                            <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                            <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
                            <!-- remove in hover only -->

                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.infantCount">
                          <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                          <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
              
              <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>

                </div>
                </ng-template>
            </td>

          </tr>
        </tbody>
      </table>
      <!-- <div class="col-md-3 "  *ngFor="let fare of item?.fare;">
       
<div class="outside-container mt-4">
  <div class="box-container " [style]="fare.fareType==='Corporate Fare'?('background-color: #CBFFCB;'):''" >
      <div class="container">
          
          <div class=" row" style="font-size: 14px;">
            <div class="col-md-10 d-flex justify-content-start">{{fare.fareType}}</div>
            <div class=" col-md-2 d-flex justify-content-start ">
                <span  style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="onClickFare(fare, item.fare,item);openPopup(item,fare)"><mat-icon style="font-size: 20px;">info</mat-icon></span>    
             </div>
          </div>
         
<div class="col-md-12 d-flex justify-content-start">


<span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span>

</div>
<div style="min-height:8vh;text-align: left;">
<span style=" font-size: 12px;" class="col-md-12 "  >
  <span class="mb-2" *ngIf="fare?.refundable===true" style="color:rgba(127, 127, 128, 0.544); ">{{fare?.refundable===true?('Refundable + '):''}}</span> -->
  <!-- <span  class="mb-2" *ngIf="fare?.refundable===false" style="color: rgba(127, 127, 128, 0.544); "> {{fare?.refundable===false?('Non Refundable + '):''}}</span> -->
  <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===true" style="color: rgba(127, 127, 128, 0.544); ">{{fare?.hasFreeMeal===true?('Free Meal'):""}}</span> -->
  <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===false" style="color: rgba(127, 127, 128, 0.544);">{{fare?.hasFreeMeal===false?('Paid Meal'):""}}</span> -->

  <!-- <span  class="mb-2" *ngIf="fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'" style="color: rgba(127, 127, 128, 0.544); ">{{fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?('Checkin ('+ fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG)+ Hand/Cabin Bag( 7KG)'):""}}</span>
  <span  class="mb-2" *ngIf="fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit!='Kilograms'" style="color: rgba(127, 127, 128, 0.544); ">{{'Hand/Cabin Bag( 7KG)'}}</span>

  
<div class="col-md-12 d-flex justify-content-start" *ngFor="let miscellanousData of fare.miscellanousData">
  
  
  <mat-icon matSuffix style="font-size: 16px ; color: #23CF19;">check_circle</mat-icon> <div class="col-md-10 " style="text-align: start;">{{miscellanousData}}</div></div>
</span>
</div>
<div  class="d-flex justify-content-center mt-2"  > -->
   
  <!-- <mat-radio-group class="col-md-12"
aria-labelledby="example-radio-group-label"
class="example-radio-group"
[(ngModel)]="fare.selected" 
>

<mat-radio-button color="primary" class="example-radio-button "  (click)="onClickFare(fare, item.fare,item)" [value]="fare.select"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
</mat-radio-group> -->


   <!-- <button *ngIf="!showSpiner" class="col-md-12"  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;" (click)="onClickFare(fare, item.fare,item);openWindow(item)"  >
    Book
  </button>  
  <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;"  ><mat-spinner  diameter="30" ></mat-spinner></button>

</div>

        </div></div></div>

      </div> -->
    </div>
  
    
  </mat-expansion-panel>
</mat-accordion>

</div>
</span>

<!--##############Return Flight#################=============================================================================-->
 <!--##############Return Flight#################=============================================================================-->
<!--###################################   Return Flight ##################################################
     ###################################  Return Flight  ################################################## 
      ################################### Return Flight ##################################################-->
<span *ngIf="messageData.airSearchRequestBaseDetails.length===2" class="row" style="min-width:1300px">
  <span class="col-md-6" *ngIf="returnFlightDetail">
  <!-- <mat-expansion-panel  hideToggle disabled style=" margin-left: 20px; margin-right: 20px; ">
   
    <mat-expansion-panel-header>
      <mat-panel-title  style="margin-left: 30px;">
        <div class="col-md-12 row  bold" style="color:rgb(32,32,32);">
        <div class="col-md-2  mb-1">Airline </div>
        &nbsp;&nbsp;&nbsp;
        <div class="col-md-2  mb-1">Departure </div>
        <div class="col-md-2  mb-1"></div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
        <div class="col-md-2  mb-1">Arrival </div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md-2  mb-1">Price</div>
       
        </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
   
  </mat-expansion-panel> -->
  <div style="height: 49vh; overflow-y: auto;">
    <mat-accordion class="example-headers-align" multi style="margin-top: 10px;">
     
  <mat-expansion-panel  [ngClass]="{'active' :activeDeparture(item)}" *ngFor="let item of flightDetail" [expanded]="true" disabled hideToggle  style="margin-top: 5px; margin-left: 10px; margin-right: 10px; ">
    <mat-expansion-panel-header >
      <mat-panel-title style="color: rgb(33,33,33);" class="row">
        <div class="col-md-1">
          <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

        
      </div>
        
        <div class="col-md-2" style="font-size: 14px;">
          {{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}
          <span style="font-size: 13px; color: grey; min-width: 10%;white-space:nowrap;">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}
          <!-- <br>  <img *ngIf="item?.flightDetailsList[0]?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
            <span >{{item?.flightDetailsList[0]?.equipmentType}}</span> -->
            <!-- <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
            <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
            <span *ngFor="let carbon of item?.flightDetailsList"> -->
              <br>  <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
              <span class="bold" style="padding-left: 6px;" *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>

          </span>

        </div>
        
        
       
        <div class="col-md-8 row"  style="white-space: nowrap;">
              
          <div class="col-md-3" >{{ item?.schDepartureTime | date:'HH:mm'}}</div>
          &nbsp;&nbsp;
          <div class="col-md-3">
          <span >{{converter(item?.travelDuration)}} </span> 
          <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(10, 210, 60) ;width: 90%;" ></div>
          <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;width: 90%;"></div>
          <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;width: 90%;"></div>

            <span class="d-flex justify-content-start" *ngIf="item?.hopCount===1" style="font-size: 13px; color: grey;align-items: start; ">{{item?.hopCount===1?('non-stop'):''}}</span>
            <span class="d-flex justify-content-start" *ngIf="item?.hopCount!=1" style="font-size: 13px; color: grey; align-items: start;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</span>
          </div>
          
          &nbsp;&nbsp;
          <div class="col-md-3" >{{item?.schArrivalTime | date:'HH:mm'}}
            <small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
            triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small>

          </div>

          
          </div>
      <div  *ngIf="!enableCheck" class="col-md-1" style="width: 40px;" class="d-flex justify-content-end">
                
        <button *ngIf="item?.dropDown===false"  mat-icon-button  (click)="selectFlight(item);onClickDepartureDown(item)" >
          <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
        </button>
        <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickDepartureUp(item)">
          <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
        </button>
        
      </div>
     
        </mat-panel-title>
      
      
        
    </mat-expansion-panel-header>
    <div *ngIf="item?.dropDown===true" class="col-md-12 row">


      <table class="styled-tables " style="white-space:nowrap; ">
        <thead>
          <tr  >
            <!-- Dynamic headers based on tableHeaders array -->
            <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
            <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
            <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
            <!-- <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th> -->
            <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
            <th style="padding: 8px;  text-align: center;text-align: left;"></th>

          </tr>
        </thead>
        <tbody class="box-shadow">
          <!-- Iterate through dynamic data rows -->
          <tr  *ngFor="let fare of item?.fare;" >
            <!-- Display structured data -->
            
            <td class=" " style="padding: 8px;" [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
              <span class="col-md-12 row" >
                <span class="col-md-10">
                  <mat-checkbox color="primary"  *ngIf="enableCheck"  (change)="selectShareData($event,item,fare)"></mat-checkbox>
                  <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                  {{fare?.fareTypeDisplay}}

                </span>
          </span>
            </td>
            <td class="" style="padding: 8px;">
              <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===true" >{{fare?.refundable===true?('Refundable'):''}}</span>
              <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===false" > {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
            
            </td>
            <!-- <td class="name-type" style="padding: 8px;">
             
            </td> -->
            <td class="" style="padding: 8px;">
              <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
              <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
            
            </td>
            <!-- <td class="" style="padding: 8px;">{{ '' }}</td> -->
            <td class="" style="padding: 8px;">
              <!-- change fun fareOMapping -->
              {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}

               <!-- {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG'):"N/A"}} -->
            </td>
            <td class="" style="padding: 8px;">{{'7KG'}}</td>
            <td  style="padding: 8px;">
             <!-- <mat-radio-group class="col-md-12"
             aria-labelledby="example-radio-group-label"
             class="example-radio-group"
             [(ngModel)]="fare.selected" 
             >
             
             <mat-radio-button color="primary" class="example-radio-button "  (click)="onClickFare(fare, item.fare,item)" value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
             </mat-radio-group> -->
             <span (click)="onClickFare(fare, item.fare,item)">
              <mat-icon class="mat-primary" *ngIf="fare.selected==='true'">radio_button_checked</mat-icon>
              <mat-icon style="color: #757575;" *ngIf="fare.selected===''">radio_button_unchecked</mat-icon>
              <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
              triggers="mouseenter:mouseleave">
              ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}}
              <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                fare?.commercialData?.finalAmount}} -->
               </span>

              
            </span> 
            <ng-template #popoverContent class="col-md-12"  >
              <div class="  col-md-12 ">

              <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                            style="overflow-y:scroll;max-height: 95%; width: 100%;">
                            <thead class="thead-light" style="white-space:nowrap;">
                              <tr>
                                <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                              </tr>
                            </thead>
                            <tbody >
                              <tr  style="height: 25px; ">
                                <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                  {{
                                  (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                  }}</td>
                              
                                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                  {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                  }}</td> -->
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.baseFare}}</td>
                              
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.finalTax}}</td>


                                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                              
                              
                              
                              </tr>
                            </tbody>
                          </table>
                          <div class=" mt-1" *ngIf="messageData.adultCount">
                            <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                             <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
            
            <!-- remove in hover only -->
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.childCount">
                          <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                          <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
            
            <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
                      <div class=" mt-1" *ngIf="messageData.infantCount">
                        <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                        <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
            
            <!-- remove in hover only -->
                          <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                            {{ entry.key }}{{ entry.value | json }},
                           </span>) -->
                        </span>
                        
                     
                    </div>

              </div>
              </ng-template> 
            </td>

          </tr>
        </tbody>
      </table>


      <!-- <div class="col-md-6 "  *ngFor="let fare of item?.fare;">

<div class="outside-container mt-4">
  <div class="box-container " [style]="fare.fareType==='Corporate Fare'?('background-color: #CBFFCB;'):''">
      <div class="container">
        <div class=" row" style="font-size: 14px;">
          <div class="col-md-10 d-flex justify-content-start" style="color: black;">{{fare.fareType}}</div>
          <div class=" col-md-2 d-flex justify-content-start "> -->
              <!-- <span  style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="onClickFare(fare, item.fare,item);openPopup(item,fare)"><mat-icon style="font-size: 20px;">info</mat-icon></span>     -->
           <!-- </div>
        </div> -->
          <!-- <div class="title" style="font-size: 14px;">
            <div class="row">
             <div class=" col-md-2  " ></div>  
            <div class="col-md-7 d-flex justify-content-center">{{fare.fareType}}</div>
            <div class=" col-md-3 row ">
              <div class="d-flex justify-content-end"> -->
                <!-- <span  style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="openPopup(item,fare)"><mat-icon>info</mat-icon></span> -->
              <!-- </div>
             </div>
           </div>
          </div> -->
         
<!-- <div class="col-md-12 d-flex justify-content-start" style="text-align: left;">
  <mat-radio-group class="col-md-12"
aria-labelledby="example-radio-group-label"
class="example-radio-group"
[(ngModel)]="fare.selected" 
>

<mat-radio-button color="primary" class="example-radio-button "  (click)="onClickFare(fare, item.fare,item)" [value]="fare.select"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
</mat-radio-group>
</div>
<div style="min-height:8vh;text-align: left;">
  <span style=" font-size: 12px;" class="col-md-12 "  >
    <span class="mb-2" *ngIf="fare?.refundable===true" style="color:rgba(127, 127, 128, 0.544); ">{{fare?.refundable===true?('Refundable + '):''}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.refundable===false" style="color: rgba(127, 127, 128, 0.544); "> {{fare?.refundable===false?('Non Refundable + '):''}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===true" style="color: rgba(127, 127, 128, 0.544); ">{{fare?.hasFreeMeal===true?('Free Meal'):""}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===false" style="color: rgba(127, 127, 128, 0.544);">{{fare?.hasFreeMeal===false?('Paid Meal'):""}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===true" style="color: rgba(127, 127, 128, 0.544); ">{{fare?.hasFreeMeal===true?('Free Meal +'):""}}</span>
  
    <span  class="mb-2" *ngIf="fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'" style="color: rgba(127, 127, 128, 0.544); ">{{fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?('Checkin ('+ fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG)+ Hand/Cabin Bag( 7KG)'):""}}</span>
    <span  class="mb-2" *ngIf="fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit!='Kilograms'" style="color: rgba(127, 127, 128, 0.544); ">{{'Hand/Cabin Bag( 7KG)'}}</span>
  
    
  <div class="col-md-12 d-flex justify-content-start" *ngFor="let miscellanousData of fare.miscellanousData">
    
    
    <mat-icon matSuffix style="font-size: 16px ; color: #23CF19;">check_circle</mat-icon> <div class="col-md-10 " style="text-align: start;">{{miscellanousData}}</div></div>
  </span>
  </div> -->
<!-- <span style=" font-size: 12px;" class="col-md-12" >
  <div class="col-md-12 d-flex justify-content-start" *ngFor="let miscellanousData of fare.miscellanousData"><mat-icon matSuffix style="font-size: 16px ; color: #23CF19;">check_circle</mat-icon> <div class="col-md-10 " style="text-align: start; color:black">{{miscellanousData}}</div></div>
</span> -->
        <!-- </div></div></div>

      </div> -->
    </div>
  </mat-expansion-panel>
</mat-accordion>
</div>
</span>

<span class="col-md-6" *ngIf="returnFlightDetail">
  <!-- <mat-expansion-panel   hideToggle disabled style=" margin-left: 20px; margin-right: 20px;">
   
    <mat-expansion-panel-header>
      <mat-panel-title  style="margin-left: 30px; ">
        <div class="col-md-12 row  bold" style="color:rgb(32,32,32);">
        <div class="col-md-2  mb-1">Airline </div>
        &nbsp;&nbsp;&nbsp;
        <div class="col-md-2  mb-1">Departure </div>
        <div class="col-md-2  mb-1"></div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
        <div class="col-md-2  mb-1">Arrival </div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md-2  mb-1">Price</div>
       
        </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
   
  </mat-expansion-panel> -->
  <div style="height: 49vh; overflow-y: auto;">
    <mat-accordion class="example-headers-align" multi style="margin-top: 10px;">

  <mat-expansion-panel [expanded]="true" [ngClass]="{'active' :activeReturn(item)}"  *ngFor="let item of returnFlightDetail" disabled hideToggle  style="margin-top: 5px; margin-left: 10px;margin-right: 10px; ">
    <mat-expansion-panel-header >
      <mat-panel-title style="color: rgb(33,33,33);" class="row">
        <div class="col-md-1">
          <img  [src]="flightlogoFilter(item?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

              </div>
        <div style="font-size: 14px; " class="col-md-2">
        {{fligthNameFilter(item?.flightDetailsList[0]?.carrierName)}}
        <span style="font-size: 13px; color: grey; white-space:nowrap;">{{item?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flightDetailsList[0]?.flightNumber}}
          <br><!--   <img *ngIf="item?.flightDetailsList[0]?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
          <span >{{item?.flightDetailsList[0]?.equipmentType}}</span> -->
          <!-- <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
          <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{item?.carbonEmission?.emission?('CO2 '+(item?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
        <span *ngFor="let carbon of item?.flightDetailsList">
         {{carbonPlus(carbon)?('CO2 '+(carbonPlus(carbon)).toFixed()+' Kg'):'-'}}
          
        </span> -->
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" style="padding-left: 6px;" *ngIf="distancePlus(item?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flightDetailsList)}}</span>

        </span>

        </div>
       
        <div class="col-md-8 row"  style="white-space: nowrap;">
              
          <div class="col-md-3" >{{ item?.schDepartureTime | date:'HH:mm'}}</div>
          &nbsp;&nbsp;
          <div class="col-md-3">
            
          <span >{{converter(item?.travelDuration)}} </span> 
          <div *ngIf="item?.hopCount===1" style="border-bottom:2px solid rgb(10, 210, 60) ;width: 90%;" ></div>
          <div *ngIf="item?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;width: 90%;"></div>
          <div *ngIf="item?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;width: 90%;"></div>

            <span class="d-flex justify-content-start" *ngIf="item?.hopCount===1" style="font-size: 13px; color: grey;align-items: start; ">{{item?.hopCount===1?('non-stop'):''}}</span>
            <span class="d-flex justify-content-start" *ngIf="item?.hopCount!=1" style="font-size: 13px; color: grey; align-items: start;">&nbsp;&nbsp;{{item?.hopCount?(item?.hopCount-1+'-'+'stop'):''}}</span>
          </div>
          &nbsp;&nbsp;
          <div class="col-md-3" >{{item?.schArrivalTime | date:'HH:mm'}}
            <small style="color: red;font-size: 12px;" ngbPopover="{{item?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
                  triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.schDepartureTime,item?.schArrivalTime)}}</small>
          </div>
        
          
          </div>
        <div *ngIf="!enableCheck" class="col-md-1" style="width: 40px;" class="d-flex justify-content-end">
                
          <button *ngIf="item?.dropDown===false"  mat-icon-button (click)="selectRFlight(item);onClickDropdown(item)" >
            <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
          </button>  
          <button *ngIf="item?.dropDown===true" mat-icon-button  (click)="onClickDropup(item)">
            <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
          </button>
         
        </div>
        </mat-panel-title>
       
      
        
    </mat-expansion-panel-header>
    
    

    <div *ngIf="item?.dropDown===true" class="col-md-12 row">
      <table class="styled-tables " style="white-space:nowrap; ">
        <thead>
          <tr  >
            <!-- Dynamic headers based on tableHeaders array -->
            <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
            <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
            <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
            <!-- <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th> -->
            <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th>
            <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
            <th style="padding: 8px;  text-align: center;text-align: left;"></th>

          </tr>
        </thead>
        <tbody class="box-shadow">
          <!-- Iterate through dynamic data rows -->
          <tr  *ngFor="let fare of item?.fare;" >
            <!-- Display structured data -->
            
            <td class="" style="padding: 8px;" [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
              <span class="col-md-12 row">
                <span class="col-md-10">
                  <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectRShareData($event,item,fare)"></mat-checkbox>

                  <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }}  -->
                  {{fare?.fareTypeDisplay }} 

                  
                </span>
          </span>
            </td>
            <td class="" style="padding: 8px;">
              <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===true" >{{fare?.refundable===true?('Refundable'):''}}</span>
              <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===false" > {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
            
            </td>
            <!-- <td class="name-type" style="padding: 8px;">
             
            </td> -->
            <td class="" style="padding: 8px;">
              <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
              <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
            
            </td>
            <!-- <td class="" style="padding: 8px;">{{ '' }}</td> -->
            <td class="" style="padding: 8px;">
              <!-- change fun fareOMapping -->
              {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}

               <!-- {{fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG'):"N/A"}} -->
            </td>
            <td class="" style="padding: 8px;">{{'7KG' }}</td>
            <td  style="padding: 8px;">
             <!-- <mat-radio-group class="col-md-12"
             aria-labelledby="example-radio-group-label"
             class="example-radio-group"
             [(ngModel)]="fare.selected" 
             >
             
             <mat-radio-button color="primary" class="example-radio-button "  (click)="onClickRFare(fare, item.fare,item)" value="true"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
             </mat-radio-group> -->
             <span (click)="onClickRFare(fare, item.fare,item)">
              <mat-icon class="mat-primary" *ngIf="fare.selected==='true'">radio_button_checked</mat-icon>
              <mat-icon style="color: #757575;" *ngIf="fare.selected===''">radio_button_unchecked</mat-icon>
              <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
              triggers="mouseenter:mouseleave">
              ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}}
              <!-- ₹{{(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                fare?.commercialData?.finalAmount}}  -->
              
             </span>

            </span>  

            <ng-template #popoverContent class="col-md-12"  >
              <div class="  col-md-12 ">

              <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                            style="overflow-y:scroll;max-height: 95%; width: 100%;">
                            <thead class="thead-light" style="white-space:nowrap;">
                              <tr>
                                <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                              </tr>
                            </thead>
                            <tbody >
                              <tr  style="height: 25px; ">
                                <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                  {{
                                  (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                                  (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):0)
                                  }}</td>
                              
                                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                                  {{
                                    (passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    (passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                                    (passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.finalTax):0)
                                  }}</td> -->
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.baseFare}}</td>
                              
                                  <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.finalTax}}</td>

                                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.fare[0]?.commercialData?.Fee?.value}}</td>
                                  
                                  
                              
                              </tr>
                            </tbody>
                          </table>
                          <div class=" mt-1" *ngIf="messageData.adultCount">
                            <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                             <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
            
            <!-- remove in hover only -->
                              <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                                {{ entry.key }}{{ entry.value | json }},
                               </span>) -->
                            </span>
                            
                         
                        </div>
                        <div class=" mt-1" *ngIf="messageData.childCount">
                          <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                          <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
            
            <!-- remove in hover only -->
                            <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                              {{ entry.key }}{{ entry.value | json }},
                             </span>) -->
                          </span>
                          
                       
                      </div>
                      <div class=" mt-1" *ngIf="messageData.infantCount">
                        <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                        <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.fare)))[0]?.fareBasis):''}}
            
            <!-- remove in hover only -->
                          <!-- (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareOMapping(fare,item,item?.fare)))[0]?.fareDetailsPerPassengerType?.taxes)">
                            {{ entry.key }}{{ entry.value | json }},
                           </span>) -->
                        </span>
                        
                     
                    </div>

              </div>
              </ng-template>
            </td>

          </tr>
        </tbody>
      </table>
      <!-- <div class="col-md-6 "  *ngFor="let fare of item?.fare;">

<div class="outside-container mt-4">
  <div class="box-container " [style]="fare.fareType==='Corporate Fare'?('background-color: #CBFFCB;'):''">
      <div class="container">
        <div class=" row" style="font-size: 14px;">
          <div class="col-md-10 d-flex justify-content-start" style="color: black;">{{fare.fareType}}</div>
          <div class=" col-md-2 d-flex justify-content-start ">
           </div>
        </div> -->
          <!-- <div class="title" style="font-size: 14px;">
            <div class="row">
             <div class=" col-md-2  " ></div>  
            <div class="col-md-7 d-flex justify-content-center">{{fare.fareType}}</div>
            <div class=" col-md-3 row ">
              <div class="d-flex justify-content-end">
              </div>
             </div>
           </div>
          </div> -->
         
<!-- <div class="col-md-12 d-flex justify-content-start" style="text-align: left;">
  <mat-radio-group class="col-md-12"
aria-labelledby="example-radio-group-label"
class="example-radio-group"
[(ngModel)]="fare.selected" 
>

<mat-radio-button color="primary" class="example-radio-button "  (click)="onClickRFare(fare, item.fare,item)" [value]="fare.select"><span style="color:rgb(1,123,254);cursor: pointer;font-weight:600;">₹{{fare?.baseFare+fare?.finalTax}}</span></mat-radio-button>
</mat-radio-group>
</div>
<div style="min-height:8vh;text-align: left;">
  <span style=" font-size: 12px;" class="col-md-12 "  >
    <span class="mb-2" *ngIf="fare?.refundable===true" style="color:rgba(127, 127, 128, 0.544); ">{{fare?.refundable===true?('Refundable + '):''}}</span>
    <span  class="mb-2" *ngIf="fare?.refundable===false" style="color: rgba(127, 127, 128, 0.544); "> {{fare?.refundable===false?('Non Refundable + '):''}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===true" style="color: rgba(127, 127, 128, 0.544); ">{{fare?.hasFreeMeal===true?('Free Meal'):""}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===false" style="color: rgba(127, 127, 128, 0.544);">{{fare?.hasFreeMeal===false?('Paid Meal'):""}}</span> -->
    <!-- <span  class="mb-2" *ngIf="fare?.hasFreeMeal===true" style="color: rgba(127, 127, 128, 0.544); ">{{fare?.hasFreeMeal===true?('Free Meal +'):""}}</span>
  
    <span  class="mb-2" *ngIf="fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit==='Kilograms'" style="color: rgba(127, 127, 128, 0.544); ">{{fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.value?('Checkin ('+ fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.value +' KG)+ Hand/Cabin Bag( 7KG)'):""}}</span>
    <span  class="mb-2" *ngIf="fareMapping(fare,item,item?.fare)[0]?.baggageInfo?.unit!='Kilograms'" style="color: rgba(127, 127, 128, 0.544); ">{{'Hand/Cabin Bag( 7KG)'}}</span>
  
    
  <div class="col-md-12 d-flex justify-content-start" *ngFor="let miscellanousData of fare.miscellanousData">
    
    
    <mat-icon matSuffix style="font-size: 16px ; color: #23CF19;">check_circle</mat-icon> <div class="col-md-10 " style="text-align: start;">{{miscellanousData}}</div></div>
  </span>
  </div> -->
<!-- <span style=" font-size: 12px;" class="col-md-12" >
  <div class="col-md-12 d-flex justify-content-start" *ngFor="let miscellanousData of fare.miscellanousData"><mat-icon matSuffix style="font-size: 16px ; color: #23CF19;">check_circle</mat-icon> <div class="col-md-10 " style="text-align: start;color:black">{{miscellanousData}}</div></div>

</span> -->
        <!-- </div></div></div>

      </div> -->
    </div>
    
  </mat-expansion-panel>
  </mat-accordion>
</div>
</span>
</span>
<!--###################################   Return Totals ##################################################
     ###################################  Return Totals ################################################## 
      ################################### Return Totals ##################################################-->
 
      <mat-expansion-panel *ngIf="messageData.airSearchRequestBaseDetails.length===2 && this.returnflight[0]?.flights.length>0" hideToggle disabled class="mb-3 "  style=" margin-left: 20px;margin-right: 20px;min-width: 98%;position: relative; bottom: 0%; ">
        <!-- <mat-expansion-panel-header class="col-md-12">
          <div *ngIf="departureFlight" class="col-md-12 row">
            <div class="col-md-6 d-flex justify-content-start" style="color:rgb(32,32,32);">
              <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( returnflight[0]?.fromAirport)}} to {{cityFilter(returnflight[0]?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>
          </div>
          <div *ngIf="returnFlight" class="col-md-6 d-flex justify-content-start" style="color:rgb(32,32,32);">
            <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( returnflight[1]?.fromAirport)}} to {{cityFilter(returnflight[1]?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>
          </div>
          </div>
          </mat-expansion-panel-header> -->
        <mat-expansion-panel-header class="col-md-12">
          <mat-panel-title style=" color: rgb(33,33,33); ">
            <img  [src]="flightlogoFilter(departureFlight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

           
            <span style="font-size: 14px; min-width: 10%">
            {{fligthNameFilter(departureFlight?.flightDetailsList[0]?.carrierName)}}
            </span>
            &nbsp;&nbsp;
            <span class="" style="white-space: nowrap;">
                
                <span >{{ departureFlight?.schDepartureTime | date:'HH:mm'}}</span>
                &nbsp;&nbsp;
                <span >{{converter(departureFlight?.travelDuration)}} </span>
                &nbsp;&nbsp;
                <span >{{departureFlight?.schArrivalTime | date:'HH:mm'}}</span>
               
              
            </span>
            </mat-panel-title>
    <mat-panel-title style="padding: 0; margin: 0;" class="d-flex justify-content-center"><span >
      <img  src="../../../assets/images/comparearrows.png" width="50" height="50" alt="">
    </span></mat-panel-title>
            <mat-panel-description *ngIf="returnFlight" style=" color: rgb(33,33,33);"  >
    
              <img  [src]="flightlogoFilter(returnFlight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">

            
              <br>
              <span style="font-size: 14px; min-width: 10%">
             
              {{fligthNameFilter(returnFlight?.flightDetailsList[0]?.carrierName)}}
    
              </span>
              
              &nbsp;&nbsp;
              <span class="" style="white-space: nowrap;">
                  
                  <span >{{ returnFlight?.schDepartureTime | date:'HH:mm'}}</span>
                  &nbsp;&nbsp;
                  <span >{{converter(returnFlight?.travelDuration)}} </span>
                  &nbsp;&nbsp;
                  <span >{{returnFlight?.schArrivalTime | date:'HH:mm'}}</span>
                 
                 
                  
              </span>
                     </mat-panel-description>
                     <span style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);"> ₹ {{returnFlight?.fare[0]?.baseFare+returnFlight?.fare[0]?.finalTax+returnFlight?.fare[0].commercialData?.finalAmount+departureFlight?.fare[0]?.baseFare+departureFlight?.fare[0]?.finalTax+departureFlight.fare[0].commercialData?.finalAmount}}</span>

                     <!-- <span style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);">
                      
                      ₹ {{
                        (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                        returnFlight?.fare[0]?.commercialData?.finalAmount+
                        (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                         (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                        departureFlight?.fare[0]?.commercialData?.finalAmount
                       }}

                    </span> -->
                     &nbsp;&nbsp;
                     <span *ngIf="userType!='EMPLOYEE'">
                      
                      <button *ngIf="!showSpiner"   mat-raised-button color="accent"   (click)="openReturnWindow()">
                      Book
                    </button>   
                    <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;" disabled  >Book</button>
    
                    </span>
                    <span *ngIf="userType==='EMPLOYEE'">
                      
                      <button *ngIf="!showSpiner"   mat-raised-button color="accent"   (click)="openReturnWindow()">
                        Select Flight
                    </button>   
                    <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;" disabled  >Select Flight</button>
    
                    </span>
    
    
            </mat-expansion-panel-header>
            <mat-expansion-panel-header class="col-md-12">
          <div *ngIf="departureFlight" class="col-md-12 row">
            <div class="col-md-6 d-flex justify-content-start" style="color:rgb(1,123,254);" (click)="openReturnPopup();onClickITINERARYTab()">
              Flight Details
          </div>
          
          </div>
          </mat-expansion-panel-header>
            </mat-expansion-panel> 
</div>
</div>
<!--###################################  pendingFlight.gif ##################################################
     ################################### pendingFlight.gif  ################################################## 
      ################################### pendingFlight.gif ##################################################-->
      <div *ngIf="!showPending&&blankList" class=" no-result-container " style="padding: 1.3rem;text-align: center;background-color: antiquewhite;">
        <div class="icon">
          <!-- Use an SVG or FontAwesome icon for the magnifying glass -->
          <!-- <img src="assets/images/" alt="No Result Icon"> -->
        </div>
        <h2>No Result Found</h2>
        <p>Sorry, there are no matching results</p>
      </div>
      <div *ngIf="showPending" >
  <div class="gif-container">
    <img src="../../../assets/images/pendingFlight.gif" >
</div>
</div>


<!--###################################  flightDetails ##################################################
     ################################### flightDetails  ################################################## 
      ################################### flightDetails ##################################################-->
      
        
    
<div class="modal" id="myMod" [style.display]="!flightDetails ? 'block' : 'none'" >
  <div class="modal-dialog" >
      <div class="modal-content " >
          <div class="modal-header title">
            <h4 class="modal-title">Flight Details</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
            </div>
            <div class="modal-body"  *ngIf="returnflight">
              <div class="mb-3 mt-1">
                <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( returnflight[0]?.fromAirport)}} to {{cityFilter(returnflight[0]?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>
            </div>
              <mat-tab-group #tabGroup  mat-stretch-tabs="false" mat-align-tabs="start" style="overflow: auto; max-height: 50vh;">
                <mat-tab  label="ITINERARY" >  
    <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of departureFlight.flightDetailsList">
      
      <div class="mb-3 mt-1">
        <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
    </div><br>
  <div class="col-md-2">
    <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">

  
<br>
{{fligthNameFilter(element?.carrierName)}}<br>
    <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
      <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
      <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
     <!--<span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.departureFlight?.carbonEmission?.emission?('CO2 '+(this.departureFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
    -->
    <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
      <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>

    </span>
</div>

<div class="col-md-2">
    {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
    <br>
    <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
</div>
<div class="col-md-2">
    <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
    <br>
    <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
   
</div>
<div class="col-md-2">
  {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
    <br>
    <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
</div>
<div class="col-md-2">
        
    <!-- <span style="font-size: 12px;">Check-in baggage</span>
    <br>
    <span style="font-size: 12px;">  Cabin baggage</span> -->
</div>
<div class="col-md-2">
    <!-- <span style="font-size: 13px;">20kg/ Adult</span>
     <br>
     <span style="font-size: 13px;">7kg/ Adult</span> -->
 </div>
    </div>

    
    

<span *ngIf="returnFlight && messageData.journeyType==='return'" >
  <div class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
    <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>
    <div class="col-md-12 mt-2 row " *ngFor="let element of returnFlight.flightDetailsList">
      <div class="mb-3 mt-1">
        <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
    </div><br>
  <div class="col-md-2">
    <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">

  
<br>
    {{fligthNameFilter(element?.carrierName)}}<br>
    <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
      <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" alt="external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2"/>
      <span style="padding-left: 4px;">{{element?.equipmentType}}</span>
      <br>
      <!-- <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{this.returnFlight?.carbonEmission?.emission?('CO2 '+(this.returnFlight?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{this.returnFlight?.carbonEmission?.emission?('CO2 '+(this.returnFlight?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{this.returnFlight?.carbonEmission?.emission?('CO2 '+(this.returnFlight?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{this.returnFlight?.carbonEmission?.emission?('CO2 '+(this.returnFlight?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span>  -->
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
      <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"><mat-icon style="font-size: large;">location_on</mat-icon> {{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>

    </span>
</div>

<div class="col-md-2">
    {{returnFlight?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
    <br>
    <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
</div>
<div class="col-md-2">
    <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
    <br>
    <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
   
</div>
<div class="col-md-2">
  {{returnFlight.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
    <br>
    <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
    <br>
    <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
</div>
<div class="col-md-2">
        
    <!-- <span style="font-size: 12px;">Check-in baggage</span>
    <br>
    <span style="font-size: 12px;">  Cabin baggage</span> -->
</div>
<div class="col-md-2">
    <!-- <span style="font-size: 13px;">20kg/ Adult</span>
     <br>
     <span style="font-size: 13px;">7kg/ Adult</span> -->
 </div>
    </div>
  </span>
    </mat-tab>
    <mat-tab  label="FARE" >
      <span *ngIf="departureFlight" class="col-md-12 mt-2 mb-2 row">

      
      <div class="col-md-5 ">

      <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                style="overflow-y:scroll;max-height: 95%; width: 100%;">
                <thead class="thead-light" >
                  <tr>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>



                  </tr>
                </thead>
                <tbody >
                  <tr  style="height: 25px; ">
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.baseFare}}</td>
                   
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.finalTax}}</td>
                    <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                      {{(passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                        (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)}}</td>
                   
                    <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                      {{(passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)}}</td> -->

                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{departureFlight?.fare[0]?.commercialData?.Fee?.value}}</td>
                  
                  
                  
                  </tr>
                </tbody>
              </table>
              <div class=" mt-1" *ngIf="messageData.adultCount">
                <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                 <span> {{passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis):''}}


                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(departureFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
            <div class=" mt-1" *ngIf="messageData.childCount">
              <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
              <span> {{passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis):''}}


                (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(departureFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                  {{ entry.key }}{{ entry.value | json }},
                 </span>)
              </span>
              
           
          </div>
          <div class=" mt-1" *ngIf="messageData.infantCount">
            <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
            <span> {{passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(departureFlight)))[0]?.fareBasis):''}}


              (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(departureFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                {{ entry.key }}{{ entry.value | json }},
               </span>)
            </span>
            
         
        </div>
            </div>
            <div  class="col-md-7" >
              <mat-progress-bar *ngIf="farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

              <div style="height:40vh; overflow: auto;"  *ngIf="json">
             <div  *ngFor="let item of json" >
              <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item.key }}</div>
              
              <div class="col-md-12"><pre [innerHTML]="item.value">{{ item.value}} </pre></div>

              </div>
            </div>
            </div>
          </span>
           
         <span *ngIf="returnFlight && messageData.journeyType==='return'" class="row col-md-12 mt-2 mb-2"  >
          <div class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

          <div class="col-md-5">


            <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                      style="overflow-y:scroll;max-height: 95%; width: 100%;">
                      <thead class="thead-light" >
                        <tr>
                          <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                          <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                          <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                          <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
      
      
      
                        </tr>
                      </thead>
                      <tbody >
                        <tr  style="height: 25px; ">
                          <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >
                            {{(passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                              (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)}}</td>
                         
                          <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                            {{(passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                            (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                            (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)}}</td>
                           -->
                           <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.baseFare}}</td>
                         
                          <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.finalTax}}</td>
                            <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                          <td class="small  mb-0 mt-0 pl-0 pb-0" >{{returnFlight?.fare[0]?.commercialData?.Fee?.value}}</td>
                                  
                                  
                        </tr>
                      </tbody>
                    </table>
                    
                  <div class=" mt-1" *ngIf="messageData.adultCount">
                    <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                     <span> {{passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis):''}}
    
    
                      (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(returnFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                        {{ entry.key }}{{ entry.value | json }},
                       </span>)
                    </span>
                    
                 
                </div>
                <div class=" mt-1" *ngIf="messageData.childCount">
                  <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                  <span> {{passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis):''}}
    
    
                    (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(returnFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                      {{ entry.key }}{{ entry.value | json }},
                     </span>)
                  </span>
                  
               
              </div>
              <div class=" mt-1" *ngIf="messageData.infantCount">
                <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                <span> {{passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(returnFlight)))[0]?.fareBasis):''}}
    
    
                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(returnFlight)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
                  </div>
                  <div class="col-md-7" >
                    <mat-progress-bar *ngIf="fareRjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

                    <div *ngIf="rJson" style="height:40vh; overflow: auto;">
                    <div  *ngFor="let item of rJson" >
                      <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item.key }}</div>
                      
                      <div class="col-md-12"><pre [innerHTML]="item.value">{{ item.value}}</pre></div>
        
                      </div>
                    </div>
                  </div>
          </span>
      </mat-tab>
      <mat-tab  label="Cancellation"  >
        <div  class="col-md-12 mt-2"  >
          <mat-progress-bar *ngIf="farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div style="height:40vh; overflow: auto;"  *ngIf="json && !departureFlight?.routeRequest?.localFareRules">
         <div  *ngFor="let item of json" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre >{{ item.value}} </pre></div>

          </div>
        </div>
        <div *ngIf="departureFlight?.routeRequest?.localFareRules">
          <!-- cancellationRuleTxt -->
          <!-- <pre> {{fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt}}</pre> -->


          <table class="styled-popup-tables ">
            <thead>
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee  <small class="grey"> (Per passenger)</small></th>
               
                <!-- + Gilpin Fee -->
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.cancellationRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>

          






          
         </div>
        </div>
        <span *ngIf="returnFlight && messageData.journeyType==='return'" class="row col-md-12 mt-2 mb-2"  >
          <div class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

        <div class="col-md-12" >
          <mat-progress-bar *ngIf="fareRjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div *ngIf="rJson && !returnFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
          <div  *ngFor="let item of rJson" >
            <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
            
            <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre >{{ item.value}}</pre></div>

            </div>
          </div>
          <div *ngIf="returnFlight?.routeRequest?.localFareRules">
            <table class="styled-popup-tables ">
              <thead>
                <tr  >
                  <!-- Dynamic headers based on tableHeaders array -->
                  <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                  <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee  <small class="grey"> (Per passenger)</small></th>
                  <!-- + Gilpin Fee -->
      
                </tr>
              </thead>
              <tbody class="grey">
                <!-- Iterate through dynamic data rows -->
                <tr   *ngFor="let schedule of convertjson(fareTypeMapping(returnFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                  <!-- Display structured data -->
                  
                 
                  <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                  
                  <td class="" style="padding: 8px;">
                    <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                    </td>
  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </span>
      </mat-tab>


      <mat-tab  label="Date Change">
        <div  class="col-md-12 mt-2" >
          <mat-progress-bar *ngIf="farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div style="height:40vh; overflow: auto;"  *ngIf="json && !departureFlight?.routeRequest?.localFareRules">
         <div  *ngFor="let item of json" >
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
          
          <div *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre>{{ item.value}} </pre></div>

          </div>
        </div>
        <div *ngIf="departureFlight?.routeRequest?.localFareRules">
          <!-- cancellationRuleTxt -->
          <!-- <pre> {{fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt}}</pre> -->


          <table class="styled-popup-tables ">
            <thead>
              <tr  >
                <!-- Dynamic headers based on tableHeaders array -->
                <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
               
    
              </tr>
            </thead>
            <tbody class="grey">
              <!-- Iterate through dynamic data rows -->
              <tr   *ngFor="let schedule of convertjson(fareTypeMapping(departureFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                <!-- Display structured data -->
                
               
                <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                
                <td class="" style="padding: 8px;">
                  <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                  
                  </td>

              </tr>
            </tbody>
          </table>

          






          
         </div>
        </div>
        <span *ngIf="returnFlight && messageData.journeyType==='return'" class="row col-md-12 mt-2 mb-2"  >
          <div class="card mb-2" style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  "><mat-icon>swap_vert</mat-icon></span></div>

        <div class="col-md-12" >
          <mat-progress-bar *ngIf="fareRjson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>

          <div *ngIf="rJson && !returnFlight?.routeRequest?.localFareRules" style="height:40vh; overflow: auto;">
          <div  *ngFor="let item of rJson" >
            <div *ngIf="item.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item.key }}</div>
            
            <div  *ngIf="item.key==='PENALTIES'" class="col-md-12"><pre>{{ item.value}}</pre></div>

            </div>
          </div>
          <div *ngIf="returnFlight?.routeRequest?.localFareRules">

            <table class="styled-popup-tables">
              <thead >
                <tr  >
                  <!-- Dynamic headers based on tableHeaders array -->
                  <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                  <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
                 
      
                </tr>
              </thead>
              <tbody class="grey">
                <!-- Iterate through dynamic data rows -->
                <tr   *ngFor="let schedule of convertjson(fareTypeMapping(returnFlight)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                  <!-- Display structured data -->
                  
                 
                  <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                  
                  <td class="" style="padding: 8px;">
                    <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    
                    </td>
  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </span>
      </mat-tab>

    </mat-tab-group>
              <div class="modal-footer">
                <div class="form-group form-inline ">
                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                </div>   
                <!-- <span style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);">
                   ₹ {{
                     (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                     (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                     (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                     (passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(returnFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     returnFlight?.fare[0]?.commercialData?.finalAmount+
                     (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                     (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                     (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.baseFare):0)+
                     (passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.adultCount*passengerTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.childCount*passengerCTypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                      (passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax?(messageData.infantCount*passengerITypeMapping(fareTypeMapping(departureFlight))[0]?.fareDetailsPerPassengerType?.finalTax):0)+
                     departureFlight?.fare[0]?.commercialData?.finalAmount
                    }}</span> -->
                    <span style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);"> ₹ {{returnFlight?.fare[0]?.baseFare+ returnFlight?.fare[0]?.finalTax+returnFlight?.fare[0]?.commercialData?.finalAmount+departureFlight?.fare[0]?.baseFare+departureFlight?.fare[0]?.finalTax+departureFlight?.fare[0]?.commercialData?.finalAmount}}</span>

              <span *ngIf="userType!='EMPLOYEE'">
                  <button *ngIf="!showSpiner" mat-raised-button color="accent" (click)="openReturnWindow()" >
                  Book
                </button>   
                <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book</button>

                </span> 
                <span *ngIf="userType==='EMPLOYEE'">
                  <button *ngIf="!showSpiner" mat-raised-button color="accent" (click)="openReturnWindow()" >
                    Select Flight
                </button>   
                <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select Flight</button>

                </span> 
              </div>
            </div>
            </div>
    </div>
</div>


<!--###################################  Email  ##################################################
     ################################### Email  ################################################## 
      ################################### Email ##################################################-->
      <!-- <p-dialog 
      header="Search Results" 
      [modal]="true"
      [(visible)]="sharePopup" 
      [style]="{ width: '80rem',height:'40rem' }" 
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
      [maximizable]="true"> -->
      <div class="modal" id="myMod" [style.display]="sharePopup ? 'block' : 'none'" >
        <div class="modal-dialog" >
            <div class="modal-content " >
                <div  class="modal-header title sticky-tabsahre">
                  <h4 *ngIf="!viewData" class="modal-title"> Search Results
                  </h4>
                  <h4 *ngIf="viewData" class="modal-title">Fare Quotations</h4>
                  <button *ngIf="viewData" mat-flat-button  style="font-size: medium;color: white; background-color: rgb(1,123,254);" class="close" data-dismiss="modal" (click)="copyToClipboard()">Copy Text</button>

                  <button *ngIf="!viewData" type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                  <button *ngIf="viewData" type="button" class="close" data-dismiss="modal" (click)="closeviewData()">&times;</button>

                  </div>
                  <!-- style="overflow: auto; max-height: 50vh;" -->
                  <div class="modal-body"  >

                    <table *ngIf="!viewData" class="share-tables " >
                      <!-- <thead>
                        <tr  >
                          <th style="padding: 8px;  text-align: center;text-align: left;" ></th>
                          <th style="padding: 8px;  text-align: center;text-align: left;"></th>
                         
                        </tr>
                      </thead> -->
                      <tbody class="">
                        <tr   >
                          
                          <td class="tdTitle " style="padding: 4px; ">Add User</td>
                          <td class="" style="padding: 4px;" >
                            <div class="row">

                            <mat-form-field class="col-md-7 " appearance="outline"style="margin-bottom:-20px">
          
                              <mat-chip-grid #chipGrids aria-label="city Selection">
                              </mat-chip-grid>
                              <div class="input-with-icon col-md-12">
                              <input  #travellerInput [formControl]="traveller" 
                                [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                                (matChipInputTokenEnd)="addTo($event)"
                                />
                                <mat-icon>arrow_drop_down</mat-icon>
                              </div>
                
                              <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                                <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
                                <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  (click)="onfilterClick(item.username)">
                                  
                                  {{item.firstName?(item.firstName+';'):''}}{{item.username}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                         <div class=" col-md-5 d-flex justify-content-start pt-2" style=" border-left: 1px solid #d2e1f5;" >
                            <button mat-raised-button (click)="onClickTo()" style="margin-right: 8px; margin-left: 8px;"><mat-icon>add</mat-icon>Add-To</button>
                            <button  mat-raised-button  (click)="onClickCC()"><mat-icon>add</mat-icon>Add-CC</button>
                          </div>
                        </div>

                          </td>
                         

                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">To</td>
                          <td class=" " style="padding: 4px; ">
                            <textarea class="form-control"  [(ngModel)]="addTO" name="to"  cols="60" rows="1"></textarea>
                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">CC</td>
                          <td class=" " style="padding: 4px; ">
                            <textarea class="form-control " [(ngModel)]="addCC" name="cc"  cols="60" rows="1"></textarea>
                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Reply-To	</td>
                          <td class=" " style="padding: 4px; ">
                            <input class="form-control"  type="text"> 
                          </td>
                        </tr>
                        <!-- <tr>
                          <td class="tdTitle " style="padding: 4px; ">Mobile No	</td>
                          <td class=" " style="padding: 4px; ">
                            <input class="form-control"  type="text" [(ngModel)]="phoneNumber"> 
                          </td>
                        </tr> -->
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Format	</td>
                          <td class=" " style="padding: 4px; " >
                            <button  *ngIf="!SelectedView" mat-raised-button [style]="viewText==='view'?('background-color:#43a8c4;color:white'):''"  (click)="onClickTitle('view')">View Text</button>
                            <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='view'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('view')">View Text</button>
                            <button *ngIf="!SelectedView" mat-raised-button [style]="viewText==='email'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('email')" >Email</button>
                            <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='email'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('email')" >Email</button>
                           <button *ngIf="!SelectedView" mat-raised-button [style]="viewText==='excel'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('excel')" >Excel Download</button>
                            <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='excel'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('excel')" >Excel Download</button>

                            <!-- <button  mat-raised-button (click)="sendWhatsApp()">WhatsApp</button> -->


                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Subject</td>
                          <td class=" " style="padding: 4px; " >
                            <input class="form-control " [(ngModel)]="subjectEmail"  name="subject"  >



                          </td>
                        </tr>
                        <tr>
                          <td class="tdTitle " style="padding: 4px; ">Greeting Message	</td>
                          <td class=" " style="padding: 4px; " >
                            <textarea class="form-control "  name="Message"  cols="60" rows="4"></textarea>



                          </td>
                        </tr>
                      </tbody>
                    </table>
                 <div *ngIf="fetchAllData && viewData"class="row" >
                    <!-- <div *ngFor="let option of returnflight; let optionIndex = index " >
                      <div *ngFor="let flight of option?.flights;let flightIndex = index" class="row">
                        <p>Option {{ flightIndex  + 1}}</p>
                          <div *ngFor="let fare of flight?.fare; let detailIndex = index" class="col-md-4">

                          
                          <p>{{ flight?.flightDetailsList[0]?.carrierName }} {{ flight?.flightDetailsList[0]?.flightNumber }} {{ option?.fromAirport }}{{ option?.toAirport }} {{ flight?.schDepartureTime | date: 'dd-MMM' }} {{ flight?.schDepartureTime | date: 'HHmm' }} {{ flight?.schArrivalTime | date: 'HHmm' }}</p>
                          <p>Ticket Cost: INR {{ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }}</p>
                          <p>Fare Type: {{ fare?.fareType }}</p>
                        </div>                   
                      </div>
                    </div>
                 -->
                 <!-- <textarea   class="form-control " [(ngModel)]="allEmailData" readonly name="area"  cols="100" rows="60"></textarea>


                 <textarea  class="form-control mt-2" readonly [(ngModel)]="allInboundEmailData" name="" id="" cols="100" rows="60"></textarea> -->

                <div  class="col-md-5">

                  <pre>{{allEmailData}}</pre>

                 </div>
                 <div *ngIf="messageData.journeyType==='return'"  class="col-md-5">

                   <pre>{{allInboundEmailData}}</pre>

                 </div>
                  </div>
                </div>
                <!-- <ng-template pTemplate="footer"> -->

                  <div class="modal-footer" *ngIf="!viewData">
                    <div class="form-group form-inline ">
                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                    </div>   
                      <button *ngIf="!SelectedView&&viewText==='view'" class="btn btn-outline-success c-width-100px shadow " (click)="onClickView()">Send</button>
                      <button *ngIf="SelectedView&&viewText==='view'" class="btn btn-outline-success c-width-100px shadow " (click)="onSelectedkView()">Send</button>
                      <button *ngIf="!SelectedView&&viewText==='email'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow "  (click)="allRequest()">Send</button>
                      <button *ngIf="SelectedView&&viewText==='email'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow " (click)="selectedRequest()" >Send</button>
                      <button *ngIf="!SelectedView&&viewText==='excel'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow "  (click)="allRequestDownload()">Excel Download</button>
                      <button *ngIf="SelectedView&&viewText==='excel'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow " (click)="selectedRequestDownload()" >Excel Download</button>

                      
                      
                      <button type="button" style="margin-left: 8px;" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                 
                  </div>
<!-- </ng-template> -->
                 <!-- </p-dialog> -->

          </div>
      </div>
    </div>
   <!-- <span #down></span> -->


    <!-- <p-sidebar [(visible)]="showSidebar" position="top"  >
      <ng-template pTemplate="headless">
      <h3>Right Sidebar</h3></ng-template>
  </p-sidebar> -->
  <span    *ngIf="returnflight&&countdown<180"
    style="background-color: rgb(6, 141, 146);padding: 10px;border-radius: 4px;color: white; position: sticky;bottom:0 ;left:0"  > 
    <span *ngIf="countdown!=0"  style="color: #fff;background-color: rgb(6, 141, 146);"> Search Session will Expire in  - {{convertSecondsToMinSec(countdown)}}</span>
    <span *ngIf="countdown===0" style="color: #fff;background-color: red;"> Search session has been expired  need to Re-Search</span>
  </span>
  <button    *ngIf="returnflight"
  (click)="scroll(tops)"  style="background-color: rgb(6, 141, 146);color: white; position: sticky;bottom:0 ;left:100%"   mat-fab><mat-icon style="margin-left: 4px;">expand_less</mat-icon></button>
  

  